import styles from "@/components/notes-status.module.css";
import { NoteSavingStatus } from "@/types";
import clsx from "clsx";
import { t } from "i18next";
import { JSX } from "react";

interface NotesStatusProps {
	isStatusHighlighted: boolean;
	savingStatus: NoteSavingStatus;
	wordCount: string;
}

function NotesStatus({
	isStatusHighlighted,
	savingStatus,
	wordCount,
}: NotesStatusProps): JSX.Element {
	return (
		<div className={clsx(styles["status-container"], "fade-in")}>
			<div>
				{t("wordCount", {
					wordCount: wordCount,
				})}
			</div>
			<div className={styles["status-divider"]}></div>
			<div>
				<i
					className={clsx(
						styles["save-status-icon"],
						savingStatus === NoteSavingStatus.SAVING && "twinkle",
						isStatusHighlighted &&
							savingStatus === NoteSavingStatus.FAILED &&
							styles["save-failed"],
						isStatusHighlighted &&
							savingStatus === NoteSavingStatus.SAVED &&
							styles["save-successful"],
						savingStatus === NoteSavingStatus.UNSAVED &&
							styles["unsaved"],
					)}
				>
					&#xeabf;
				</i>
				{
					{
						[NoteSavingStatus.UNSAVED]: t("unsaved"),
						[NoteSavingStatus.SAVING]: t("saving"),
						[NoteSavingStatus.SAVED]: t("saved"),
						[NoteSavingStatus.FAILED]: t("failedToSave"),
					}[savingStatus]
				}
			</div>
		</div>
	);
}

export default NotesStatus;
